module.exports = __webpack_public_path__ + "static/media/IMG_0050.e8303c46.jpg";